import { httpClient, httpClientUrlStringBuilder } from '@/network/clientController'

/** Get Customer Information
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customers
*/
export const requestCustomerInfo = () => {
	return httpClient({
		method: 'GET',
		url: 'customers',
		isCancellable: true
	})
}

/** Put Customer Information
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/PUT_customers
*/
export const requestChangeDefaultPhoneNumber = payload => {
	return httpClient({
		method: 'PUT',
		url: 'customers',
		data: { msisdn: payload }
	})
}

/** Change user friendlyName
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/PUT_customersfriendlyUsername
*/
export const changeUserFriendlyName = payload => {
	return httpClient({
		method: 'PUT',
		url: 'customers/friendlyUsername',
		data: payload
	})
}

/** Update Customer Image
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_customersimage
*/
export const updateCustomerImage = payload => {
	return httpClient({
		method: 'POST',
		url: 'customers/image',
		data: payload
	})
}

/** Delete Customer Image
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/DELETE_customersimage
*/

export const deleteCustomerImage = () => {
	return httpClient({
		method: 'DELETE',
		url: 'customers/image'
	})
}

/** Request Customer Image Url
@docs
*/
export const requestCustomerImageUrl = () => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: 'customers/image'
	})
}

/** Request Customer Image Url
@docs
*/
export const requestAssociatedCustomers = () => {
	return httpClient({
		method: 'GET',
		url: 'customers/associatedCustomers',
		isCancellable: true
	})
}

/** Request QR Code Image Url
@docs
*/
export const requestQRCodeImageUrl = () => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: 'smart-transfer/qrcode'
	})
}

/** Gets client info without security masks for form use
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customersunmaskedInformation
*/
export const getClientInfoWithoutMasks = payload => {
	return httpClient({
		method: 'GET',
		url: '/customers/unmaskedInformation',
		isCancellable: true
	})
}

/** Validate client nif
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetcostumersvalidateNif
*/
export const validateClientNif = payload => {
	return httpClient({
		method: 'GET',
		url: 'customers/validateNif',
		isCancellable: true
	})
}
